import script from "./TopBar.vue?vue&type=script&lang=js&setup=true"
export * from "./TopBar.vue?vue&type=script&lang=js&setup=true"

import "./TopBar.vue?vue&type=style&index=0&id=4a77628e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a77628e"]])

export default __exports__